// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".b54a3fffed3c195f78a5bb4fb8bc7a54.js";
};